import {
  BILL_LOCATION_VALUES,
  type BillLocationValue,
} from '@/constants/bill-location'

export type OptionalBillLocation = '' | BillLocationValue

export function normalizeDefaultLocation(
  value: string | null | undefined,
): OptionalBillLocation {
  if (value && (BILL_LOCATION_VALUES as readonly string[]).includes(value)) {
    return value as BillLocationValue
  }
  return ''
}

export function resolveRequiredLocation(
  value: string | null | undefined,
  fallback: BillLocationValue = BILL_LOCATION_VALUES[0],
): BillLocationValue {
  const normalized = normalizeDefaultLocation(value)
  return normalized || fallback
}

export function parseLocationSearchParam(
  value: string | undefined,
  defaultLocation?: OptionalBillLocation,
): BillLocationValue {
  if (value === 'chumphon' || value === 'chanthaburi') {
    return value
  }
  return resolveRequiredLocation(defaultLocation)
}
